var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec4Bk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0331 26H33.0387V11.9945H27.7238C27.5801 8.11602 29.9503 5.81768 34.7624 5.24309L33.6133 0C24.7072 0.287293 19.0331 4.16575 19.0331 14.5801V26ZM0 26H14.0055V11.9945H8.69061C8.47514 8.11602 10.8453 5.81768 15.6575 5.24309L14.5801 0C5.60221 0.287293 0 4.16575 0 14.5801V26Z",
    fill: "#226CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec4Bk);
export default __webpack_public_path__ + "static/media/sec-4-bk.b12e1632a75ee94ebc74c9bcfe558471.svg";
export { ForwardRef as ReactComponent };